import { render, staticRenderFns } from "./GraphicPage.vue?vue&type=template&id=4bf0c20d&scoped=true&"
import script from "./GraphicPage.vue?vue&type=script&lang=ts&"
export * from "./GraphicPage.vue?vue&type=script&lang=ts&"
import style0 from "./GraphicPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GraphicPage.vue?vue&type=style&index=1&id=4bf0c20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0c20d",
  null
  
)

export default component.exports